var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg065Angle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "26,86 11.2,40.4 50,12.2 88.8,40.4 74,86 ",
    stroke: "#000",
    strokeWidth: 8,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg065Angle);
export default __webpack_public_path__ + "static/media/06-5-angle.3487f4e53a09e2c6ae2155b7f4ebd009.svg";
export { ForwardRef as ReactComponent };